import Cookies from 'js-cookie'

const NEED_PLAN_KEY = 'subscription_need_plan'
const NEED_PLAN_DATE_KEY = 'subscription_need_plan_date'
const NEED_PLAN_INSTITUTE_KEY = 'subscription_need_plan_institute_id'
const NEED_PLAN_USER_KEY = 'subscription_need_plan_user_id'

const COOKIE_OPTS = { expires: 1, path: '/', sameSite: 'Lax' }

const NEED_PLAN_COOKIE_KEYS = [
  NEED_PLAN_KEY,
  NEED_PLAN_DATE_KEY,
  NEED_PLAN_INSTITUTE_KEY,
  NEED_PLAN_USER_KEY,
]

const getTodayKey = () => new Date().toISOString().slice(0, 10)

export const readCachedNeedPlan = (instituteId, userId) => {
  if (instituteId == null) return null

  try {
    const checkedDate = Cookies.get(NEED_PLAN_DATE_KEY)
    if (checkedDate !== getTodayKey()) return null

    const cachedInstituteId = Cookies.get(NEED_PLAN_INSTITUTE_KEY)
    const cachedUserId = Cookies.get(NEED_PLAN_USER_KEY)
    if (String(cachedInstituteId) !== String(instituteId)) return null
    if (String(cachedUserId) !== String(userId ?? 'unknown')) return null

    const raw = Cookies.get(NEED_PLAN_KEY)
    if (raw === undefined || raw === null || raw === '') return null

    return raw === 'true'
  } catch {
    return null
  }
}

export const writeCachedNeedPlan = (instituteId, userId, needPlan) => {
  if (instituteId == null) return

  try {
    const today = getTodayKey()
    Cookies.set(NEED_PLAN_KEY, needPlan ? 'true' : 'false', COOKIE_OPTS)
    Cookies.set(NEED_PLAN_DATE_KEY, today, COOKIE_OPTS)
    Cookies.set(NEED_PLAN_INSTITUTE_KEY, String(instituteId), COOKIE_OPTS)
    Cookies.set(NEED_PLAN_USER_KEY, String(userId ?? 'unknown'), COOKIE_OPTS)
  } catch {
    /* ignore */
  }
}

export const clearCachedNeedPlan = () => {
  NEED_PLAN_COOKIE_KEYS.forEach((key) => {
    Cookies.remove(key, { path: '/' })
    Cookies.remove(key)
  })
}
